module.exports = __webpack_public_path__ + "static/media/avatar.39c87c99.jpg";